import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import { AppConfig } from '../config/app.config'

// Локальный тип вместо RootState: импорт store сюда создал бы цикл
// store -> api -> base-query -> store.
type StateWithAuth = { auth?: { token?: string | null } }

export const baseQuery = fetchBaseQuery({
  baseUrl: AppConfig.get('REACT_APP_API_URI'),
  prepareHeaders: (headers, api) => {
    const token = (api.getState() as StateWithAuth)?.auth?.token

    if (token) {
      headers.set('Authorization', `Bearer ${ token }`)
    }

    return headers
  }
})
